<template>
  <div id="headerBanner" :class="{ minimal: !heading || !subheading, sm: smAndDown }">
    <v-container class="pa-0 pa-sm-0 pa-md-8">
      <h2 v-if="heading" class="h1"><i v-if="icon" :class="`${icon} mr-2`"></i>{{ heading }}</h2>
      <h3 v-if="subheading">{{ subheading }}</h3>
    </v-container>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import { useDisplay } from 'vuetify';

  export default defineComponent({
    name: 'HeaderBanner',
    components: {},
    props: {
      heading: {
        type: String,
        require: false,
      },
      subheading: {
        type: String,
        require: false,
      },
      icon: {
        type: String,
        require: false,
      },
    },
    setup() {
      const { smAndDown } = useDisplay();

      return {
        smAndDown,
      };
    },
  });
</script>

<style lang="scss" scoped>
  @import '@/scss/configs/colors';

  #headerBanner {
    padding: 40px 0;
    height: 200px;
    display: flex;
    align-items: center;
    box-shadow: 0 10px 6px 0 rgba($color-black, 0.16);
    background: linear-gradient(45deg, rgba($color-marine, 1) 30%, rgba($color-sky, 1) 100%);
    position: relative;
    z-index: 92;

    &.minimal {
      height: 120px;
    }

    h2,
    h3 {
      color: $color-white;
    }

    &.sm {
      height: auto;
      padding: 10px 0;
      text-align: center;
    }
  }
</style>
